import { Listbox as HeadlessListbox, Transition } from "@headlessui/react";
import { Fragment } from "react";
import { HiOutlineCheck, HiSelector } from "react-icons/hi";

function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(" ");
}

const Listbox: React.FC<{
  options: string[];
  onChange: (value: string | string[]) => void;
  selectedValue?: string | string[] | null;
  placeholder?: string | null;
  className?: string;
  hoverClassName?: string;
  activeClassName?: string;
  multiple?: boolean;
}> = ({
  options,
  onChange,
  selectedValue,
  placeholder,
  className,
  hoverClassName,
  activeClassName,
  multiple,
}) => {
  return (
    <div className="w-full">
      <HeadlessListbox
        value={selectedValue}
        onChange={(value) => {
          if (value !== null) {
            onChange(value);
          }
        }}
        multiple={multiple || false}
      >
        {({ open }) => (
          <div className="relative">
            <HeadlessListbox.Button
              className={classNames(
                className || "",
                "relative w-full cursor-default py-1 pl-2 pr-10 text-left shadow-sm"
              )}
            >
              {multiple ? (
                <div className="flex">
                  {Array.isArray(selectedValue) && selectedValue.length > 0 ? (
                    selectedValue.map((v) => {
                      return (
                        <div
                          key={v}
                          className="rounded bg-indigo-100 mx-1 px-1"
                        >
                          {v}
                        </div>
                      );
                    })
                  ) : (
                    <span className="block truncate">{placeholder}</span>
                  )}
                </div>
              ) : (
                <span className="block truncate">
                  {selectedValue || placeholder}
                </span>
              )}
              <span className="pointer-events-none absolute inset-y-0 right-0 flex items-center pr-2">
                <HiSelector
                  className="h-5 w-5 text-gray-400"
                  aria-hidden="true"
                />
              </span>
            </HeadlessListbox.Button>

            <Transition
              show={open}
              as={Fragment}
              leave="transition ease-in duration-100"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <HeadlessListbox.Options className="absolute z-10 mt-1 w-full max-h-60 overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                {options.map((option) => (
                  <HeadlessListbox.Option
                    key={option}
                    className={({ active }) =>
                      classNames(
                        active
                          ? hoverClassName || "text-white bg-[#352990]"
                          : "text-gray-900",
                        "relative cursor-default select-none py-2 pl-3 pr-9"
                      )
                    }
                    value={option}
                  >
                    {({ selected, active }) => (
                      <>
                        <span
                          className={classNames(
                            selected ? "font-medium" : "font-normal",
                            "block truncates"
                          )}
                        >
                          {option}
                        </span>

                        {selected ? (
                          <span
                            className={classNames(
                              active
                                ? hoverClassName || "text-white"
                                : activeClassName || "text-[#352990]",
                              "absolute inset-y-0 right-0 flex items-center pr-4"
                            )}
                          >
                            <HiOutlineCheck
                              className="h-5 w-5"
                              aria-hidden="true"
                            />
                          </span>
                        ) : null}
                      </>
                    )}
                  </HeadlessListbox.Option>
                ))}
              </HeadlessListbox.Options>
            </Transition>
          </div>
        )}
      </HeadlessListbox>
    </div>
  );
};
export default Listbox;
